export const targetProfilePrompt = `Generate a reference target profile for this job position. 

Return the response as a valid JSON object with the following structure:
{
  "experience": [
    {"title": "Experience title", "description": "Brief description of required experience"}
  ],
  "traits": [
    {"title": "Trait name", "description": "Brief description of the trait"}
  ]
}

REQUIREMENTS:
- Generate 4-6 relevant experiences that would make a candidate successful
- Generate 5-10 important traits for this role (maximum 10)
- Keep descriptions concise and specific
- Focus on practical, measurable qualities
- Ensure all titles and descriptions are professional and clear

Return ONLY the JSON object, no additional text or markdown formatting.`;
